
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/villa-configurator/summary",
      function () {
        return require("private-next-pages/villa-configurator/summary/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/villa-configurator/summary"])
      });
    }
  